import React from "react";
import { RiMenu3Fill } from "react-icons/ri";
import { TbCircleArrowRightFilled } from "react-icons/tb";

interface ButtonProps {
  text: string;
  background: string;
  rounded: boolean;
  transparent: boolean;
  onClick?: (() => void) | null;
}

export const AppButton: React.FC<ButtonProps> = ({
  text,
  background,
  rounded,
  transparent,
  onClick,
}) => {
  const borderRadius = rounded ? "99px" : "0px";
  const backgroundColor = transparent ? "transparent" : "bg-gray-900";
  const buttonStyles = `px-5 !align-baseline py-2  h-fit flex flex-row justify-center items-center text-md  text-white hover:text-black  hover:in-expo hover:duration-300 ${backgroundColor}`;

  return (
    <button
      onClick={() => onClick && onClick()}
      className={buttonStyles}
      style={{ borderRadius }}
    >
      {text}
    </button>
  );
};

export const MenuBtn = (props) => {
  return (
    <div
      onClick={props.method}
      className="tablet:flex desktop:hidden justify-center items-center px-4 rounded-[99px] py-2 bg-green_s4/50"
    >
      <RiMenu3Fill className="text-white text-2xl" />
    </div>
  );
};

interface IconButtonProps {
  backgroundColor: string;
  textStyle: string;
  iconColor: string;
  Icon?: React.ElementType; // This allows you to pass an icon component from react-icons
  text: string;
  onClick?: () => void;
}

export const IconButton: React.FC<IconButtonProps> = ({
  backgroundColor,
  iconColor,
  Icon,
  text,
  onClick,
  textStyle,
}) => {
  return (
    <button
      onClick={() => onClick}
      className={`flex items-center w-fit justify-center px-4 ${
        Icon ? "ps-7" : "px-5"
      } py-1 border gap-3 border-${backgroundColor} rounded-full transition-all duration-300 ${backgroundColor}`}
    >
      <span className={`${textStyle} text-lg font-medium`}>{text}</span>
      {Icon && <Icon className={`text-3xl ${iconColor} md:text-0`} />}
    </button>
  );
};

export const GreenIconButton: React.FC<IconButtonProps> = ({
  Icon,
  text,
  onClick,
  textStyle,
}) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      className={`flex items-center border-none outline-none w-fit  justify-center px-4 ${
        Icon ? "ps-7 magic-btn" : "px-5"
      } py-1 gap-3  bg-gray-900 rounded-full h-fit transition-all duration-300`}
    >
      <span className={`${textStyle} text-white p-0 text-lg font-medium`}>
        {text}
      </span>
      {Icon && <Icon className={`text-3xl text-white  md:text-0`} />}
    </button>     
  );
};

export const WhiteIconButton: React.FC<IconButtonProps> = ({
  Icon,
  text,
  onClick,
  textStyle = "text-green_s4",
  backgroundColor,
}) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      className={`flex items-center w-fit ${
        Icon ? " ps-7" : "px-7"
      } justify-center px-3 py-1 border gap-3 border-white bg-white rounded-full ease-in transition-all duration-300 ${backgroundColor}`}
    >
      <span className={`${textStyle} text-md desktop:text-lg  font-medium`}>
        {text}
      </span>
      {Icon && (
        <Icon
          className={`text-xl desktop:text-2xl ${textStyle}  md:text-0 transition-transform duration-300 ease-in-expo`}
        />
      )}
    </button>
  );
};

//Green icon button without the arrow icon
export const GreenButton: React.FC<IconButtonProps> = ({
  text,
  onClick,
  textStyle,
}) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      className={`flex items-center w-fit magic-btn justify-center px-4 ps-7 py-1 border gap-3 border-gray-900 bg-gray-900 rounded-full h-fit transition-all duration-300`}
    >
      <span className={`${textStyle} text-white text-lg font-medium`}>
        {text}
      </span>
    </button>
  );
};

//White icon button without the arrow icon
export const WhiteButton: React.FC<IconButtonProps> = ({
  text,
  onClick,
  textStyle = "",
  backgroundColor,
}) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      className={`flex items-center w-fit   magic-btn justify-center px-3 ps-7 py-1 border gap-3 border-white bg-white rounded-full ease-in transition-all duration-300`}
    >
      <span
        className={`${textStyle} text-md desktop:text-lg text-green_s4 font-medium`}
      >
        {text}
      </span>
    </button>
  );
};
